export default "/_next/static/images/4264c795d7f3d2f092343dfcf6291747.jpg";